export default __webpack_public_path__ + "static/media/virginia.cc838ace.jpg";